import React from 'react';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, apiRequest } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  isGridFormValid,
  IsSectionVisible,
  UpdateColumnWithConfiguration
} from '../../utils/helper';
import GridTable from '../common/Table/Table';
import store from '../../store/appStore';
import { SECTIONS } from '../../constants/appConstants';
import { serviceTypePayCodeMappingColumnList } from '../../constants/MockData';
import _ from 'lodash';

class ServiceTypeAndPayCode extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      isInAddMode: false,
      serviceTypePaycodeData: [],
      paycodeMasterData: [],
      configuration: [],
      selectedEditRowId: undefined,
      updateData: {
        serviceTypeId: 0,
        payCodeId: 0,
        code: null
      },
      serviceTypePayCodeMappingColumn: _.cloneDeep(serviceTypePayCodeMappingColumnList)
    };
  }

  componentDidMount () {
    this.getRequiredData();
  }

    getRequiredData = () => {
      this._asyncRequest = apiBatchRequest([
        {
          url: API_URL.Users.GetPaycode,
          key: 'paycodeMasterData'
        },
        {
          url: API_URL.Users.GetServiceTypePaycode,
          key: 'serviceTypePaycodeData'
        }
      ])
        .then(({ paycodeMasterData, serviceTypePaycodeData }) => {
          this._asyncRequest = null;
          if (serviceTypePaycodeData.success !== true) {
            ShowToast('Something went wrong', toastType.ERROR, 5000, 500, 'Server error');
          }
          this.setState({
            serviceTypePaycodeData: serviceTypePaycodeData.data || [],
            paycodeMasterData: paycodeMasterData.data || [],
            configuration: serviceTypePaycodeData.config || []
          });
        })
        .catch(() => {
          this._asyncRequest = null;
        });
    };

    GetServiceTypePaycode = () => {
      apiRequest({
        url: API_URL.Users.GetServiceTypePaycode
      }).then(({ data: response }) => {
        this.setState({
          serviceTypePaycodeData: response || []
        });
      });
    };

    cancelMode = () => {
      this.setState({ selectedEditRowId: undefined, isInAddMode: false, updateData: undefined, serviceTypePayCodeMappingColumn: _.cloneDeep(serviceTypePayCodeMappingColumnList) }, () => this.GetServiceTypePaycode());
    };

    isValidForm = () => {
      let IsValid = true;
      const { updateData, serviceTypePayCodeMappingColumn } = this.state;
      serviceTypePayCodeMappingColumn.forEach((ele) => {
        isGridFormValid(updateData[ele.key], ele, updateData);
        if (ele.isInErrorState === true) {
          IsValid = false;
        }
      });
      this.setState({ serviceTypePayCodeMappingColumn }, this.forceUpdate());
      return IsValid;
    };

    saveUpdatedRecord = () => {
      if (!this.isValidForm()) { return false; }
      const newParam = this.state.updateData;
      const params = {
        payCodeId: newParam.payCodeId,
        serviceTypeId: newParam.serviceTypeId
      };

      apiPost({
        url: API_URL.Users.UpdateServiceTypePayCodeConfiguration,
        params: {},
        postBody: params
      }).then(({ data: response }) => {
        // debugger;
        if (response.success === true) {
          ShowToast(this.state.isInAddMode ? 'Record added successfully.' : 'Record updated successfully.', toastType.SUCCESS, 5000, 500);
          this.setState({
            updateData: undefined,
            selectedEditRowId: undefined
          });
          this.GetServiceTypePaycode();
        } else {
          ShowToast(response.errorMessage, toastType.ERROR, 5000, 500);
        }
      });
    };

    renderActionColumn = (cellInfo) => {
      return (
        <>
          {this.state.selectedEditRowId !== undefined && cellInfo.serviceTypeId === this.state.selectedEditRowId.value
            ? (
            <>
              <Tooltip title="Save Record">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => {}}>
                  <SaveIcon fontSize="small" size="small" onClick={this.saveUpdatedRecord} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.cancelMode}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
              )
            : (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_SERVICE_TYPE_PAYCODE, SECTIONS.ADD_EDIT)) && (
            <Tooltip title="Edit Record">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  this.setState({ selectedEditRowId: { key: 'serviceTypeId', value: cellInfo.serviceTypeId }, isInAddMode: false, updateData: { ...cellInfo } });
                }}
              >
                <EditIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
              )}
        </>
      );
    };

    handleTableEditChange = (value, fieldName, row, addMode) => {
      const param = { ...this.state.updateData };
      const { serviceTypePayCodeMappingColumn, paycodeMasterData } = this.state;

      if (fieldName === 'payCode') {
        const valueOfpPayCode = [];
        value.forEach(val => {
          paycodeMasterData.find((x) => x.payCode === val) &&
          valueOfpPayCode.push(paycodeMasterData.find((x) => x.payCode === val).payCodeId);
        });
        param.payCodeId = valueOfpPayCode.join('|');
        param[fieldName] = value.join('|');
      } else {
        param[fieldName] = value;
      }

      isGridFormValid(value, serviceTypePayCodeMappingColumn.find(x => x.key === fieldName), param);

      this.setState({ updateData: param, reloadTable: !this.state.reloadTable });
    };

    render () {
      const { paycodeMasterData, serviceTypePayCodeMappingColumn, serviceTypePaycodeData, updateData, reloadTable, selectedEditRowId, isInAddMode } = this.state;
      const EditSource = [];
      EditSource.push(
        { key: 'paycodeMasterData', data: paycodeMasterData }
      );
      return (
            <>
                <Table
                    aria-labelledby="tableMenuTitle"
                    size={'small'}
                    aria-label="configuration table"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell
                                key={'configureHeader'}
                                className="content-header"
                                colSpan={2}
                            >
                                <div className="content-header d-flex">
                                    {' '}
                                    <div
                                        className="col-xs-11"
                                        style={{ display: 'inline-block', alignItems: 'center' }}
                                    >
                                        Service Type And Paycode Configuration
                                    </div>
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                              <GridTable
                                  columns={UpdateColumnWithConfiguration(serviceTypePayCodeMappingColumn, this.state.configuration, [])}
                                  data={serviceTypePaycodeData}
                                  config={serviceTypePayCodeMappingColumn}
                                  renderActionColumn={this.renderActionColumn}
                                  selectedEditRowId={selectedEditRowId}
                                  isInAddMode={isInAddMode}
                                  EditSource={EditSource}
                                  handleTableEditChange={this.handleTableEditChange}
                                  updateData={updateData}
                    reload={reloadTable}
                    isInline={true}
                              ></GridTable>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
      );
    };
}

export default ServiceTypeAndPayCode;
